"use client";

import Input from "@client/components/formik/input";
import Fieldset from "@client/components/lead-form/components/fieldset";
import {
	faCoins,
	faMoneyBill,
	faSackDollar,
} from "@fortawesome/free-solid-svg-icons";
import { faCoin } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { setUserInteractionDataAttribute } from "@shared/constants";
import kebabToCamelCase from "@shared/functions/kebabToCamelCase";

import type { CommonTileProps } from "@ui/js/components/tiles/common-tile-resources";
import { Tile } from "@ui/js/components/tiles/tile";
import { useFormikContext } from "formik";

const INPUT_ID_AND_LABEL_HTMLFOR = "debt-amount";
const FIELD_NAME_SELECTOR = kebabToCamelCase(INPUT_ID_AND_LABEL_HTMLFOR);

export default function DebtAmount({
	colorOverride,
	styleOverride,
}: {
	colorOverride?: CommonTileProps["color"];
	styleOverride?: CommonTileProps["componentStyle"];
}) {
	const { setFieldValue } = useFormikContext();

	const handleClick = (e: any) => {
		setFieldValue(FIELD_NAME_SELECTOR, e.currentTarget.value);
	};
	return (
		<Fieldset legend="How much debt do you owe?">
			<Input
				type="hidden"
				name={FIELD_NAME_SELECTOR}
				id={INPUT_ID_AND_LABEL_HTMLFOR}
			/>
			<Tile
				{...setUserInteractionDataAttribute(
					`lead-form__${INPUT_ID_AND_LABEL_HTMLFOR}__10k-20k`,
				)}
				color={colorOverride}
				componentStyle={styleOverride}
				iconLeft={<FontAwesomeIcon icon={faCoin} />}
				label="$10k - $20k"
				value="$10k_to_$20k"
				onClick={handleClick}
			/>
			<Tile
				{...setUserInteractionDataAttribute(
					`lead-form__${INPUT_ID_AND_LABEL_HTMLFOR}__20k-40k`,
				)}
				color={colorOverride}
				componentStyle={styleOverride}
				iconLeft={<FontAwesomeIcon icon={faCoins} />}
				label="$20k - $40k"
				value="$20k_to_$40k"
				onClick={handleClick}
			/>
			<Tile
				{...setUserInteractionDataAttribute(
					`lead-form__${INPUT_ID_AND_LABEL_HTMLFOR}__40k-100k`,
				)}
				color={colorOverride}
				componentStyle={styleOverride}
				iconLeft={<FontAwesomeIcon icon={faMoneyBill} />}
				label="$40k - $100k"
				value="$40k_to_$100k"
				onClick={handleClick}
			/>
			<Tile
				{...setUserInteractionDataAttribute(
					`lead-form__${INPUT_ID_AND_LABEL_HTMLFOR}__over-100k`,
				)}
				color={colorOverride}
				componentStyle={styleOverride}
				iconLeft={<FontAwesomeIcon icon={faSackDollar} />}
				label="Over $100k"
				value="over_$100k"
				onClick={handleClick}
			/>
		</Fieldset>
	);
}
